import React, { createContext, useState, useEffect } from 'react';
import PubSub from 'pubsub-js'
import { useImmer } from 'immer';
import { Button, Card } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const CustomerUserItem = (props) => {
    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Customer User</div>
                <div className="card-btn-group">
                    <LinkContainer to={'/admin/accounts'}>
                        <Button variant="secondary" size="sm">Close</Button>
                    </LinkContainer>
                </div>
            </Card.Header>
            <Card.Body>
            </Card.Body>
        </Card>
    )
}

export default CustomerUserItem;